;(function () {

"use strict";

var sendEmail = false;
var addFilters = false;
var addExtraProductData = false;
var addExtraVariantData = false;

var filterRowTemplate = require('../views/templates/filter-row.html');

var ExportFormView = Backbone.View.extend({
  initialize: function () {
    this.objectType = $("select.object-type").val();
    this.$filters = this.$el.find('.filters');
    this.$el.find('.add-filter').trigger('click');
    this.$copy = $('#object-type-name');
    this.onSelectChange();
  },
  submit: function (e) {
    this.post();
    return false;
  },
  post: function (e) {
    var data = { 'object-type': this.$el.find('select.object-type').val() };

    if (sendEmail) {
      if (this.$el.find('input.alt-email').val()) {
        data.email = this.$el.find('input.alt-email').val();
      }
    }

    if (this.$el.find('input.link-to-file').is(':checked')) {
      data['link-to-file'] = true;
    }

    if (this.$el.find('input.include-all-configured-metafields').is(':checked')) {
      data['include-all-configured-metafields'] = true;
    }

    if (addFilters) {
      var filterStr = '';

      this.$filters.find('select').each(function () {
        var key = $(this).val();
        var val = $(this).parent().parent().find('input').val();

        filterStr += '&'+key+'='+window.encodeURIComponent(val);
      });

      data.filters = '?' + filterStr.slice(1);
    }

    if (addExtraProductData && this.objectType === 'product') {
      var extraProductData = [];
      
      this.$el.find('#extra-data-options').find('input[type="checkbox"]').each(function () {
        if ($(this).is(':checked')) {
          extraProductData.push($(this).attr('name'));
        }
      })

      data['extra-product-data'] = extraProductData.join(',');
    }

    if (addExtraVariantData && this.objectType === 'variant') {
      var extraProductData = [];
      
      this.$el.find('#extra-variant-data-options').find('input[type="checkbox"]').each(function () {
        if ($(this).is(':checked')) {
          extraProductData.push($(this).attr('name'));
        }
      })

      data['extra-product-data'] = extraProductData.join(',');
    }

    data.__shop__ = window.data.shop;

    $.post('export-csv', data, this.onComplete.bind(this));

    ShopifyApp.Bar.loadingOn();
  },
  onComplete: function (d) {
    ShopifyApp.Bar.loadingOff();

    if (typeof d !== 'object') {
      ShopifyApp.Modal.alert({
        title: 'Error Running Export',
        message: "The export did not run successfully. Please ensure you filled out the form correctly. If the problem persists please email us at jason@thebestagency.com."
      });

      return;
    }

    if (d.status === 'error') {
      ShopifyApp.Modal.alert({
        title: 'Export Failed',
        message: d.message
      });
    } else {
      ShopifyApp.Modal.alert({
        title: 'Export Successful',
        message: "The export process has begun. It may take up to a few hours to complete depending on the number of objects in your store. Please do not modify your store during this time. When the export has finished the store owner will receive an email in his or her inbox."
      });
      this.$el.find('button[type="submit"]').addClass('disabled').text('Running Export').attr('disabled', 'disabled');
    }
  },
  updateFilterOptions: function() {
    var $selects = this.$filters.find('select');
    var activeFilters = [];

    $selects.each(function () {
      activeFilters.push($(this).val());
    });

    this.$filters.find('option').each(function() {
      // console.log(this.selected);
      // console.log($(this).is(':selected'));
      if ($(this).closest('select').val() === $(this).val()) { 
        $(this).attr('selected', 'selected');
        return true;
      } else {
        $(this).removeAttr('selected');
      }

      if (activeFilters.indexOf($(this).val()) !== -1) {
        if ($(this).parent().is('span')) {

        } else {
          $(this).wrap('<span/>');
        }
      } else if ($(this).parent().is('span')) {
        $(this).unwrap('span');
      }
    });
  },
  onSelectChange() {
    this.objectType = this.$el.find('select.object-type').val();
    this.$filters.empty();
    this.$el.find('.add-filter').trigger('click');

    if (this.objectType === 'variant' || this.objectType === 'shop') {
      this.$el.find('.add-filter').hide();
    } else {
      this.$el.find('.add-filter').show();
    }

    addFilters = false;
    $('input[name="add-filters"]').attr('checked', false);
    $('input[name="add-filters"]').parent().parent().next().hide();

    addExtraProductData = false;
    addExtraVariantData = false;
    this.$el.find('.auto-toggle input[type="checkbox"]').attr('checked', false);

    this.$el.find('.product-only').hide();
    this.$el.find('.variant-only').hide();
    this.$el.find('.'+this.objectType+'-only.auto-toggle').show();

    this.$copy.text(this.objectType.replace('_', ' ') + 's');
  },
  events: {
    'submit': 'submit',
    'change input[name="add-filters"]': function (e) {
      if ($(e.target).is(':checked')) {
        addFilters = true;
        $(e.target).parent().parent().next().show();
      } else {
        addFilters = false;
        $(e.target).parent().parent().next().hide();
      }   
    },
    'click button.add-filter': function (e)  {
      e.preventDefault();
      e.stopPropagation();

      this.$filters.find('.info-link').remove();

      var html = _.template(filterRowTemplate)({ objectType: this.objectType });
      var $html = $(html);

      var $selects = this.$filters.find('select');
      var activeFilters = [];

      $selects.each(function () {
        activeFilters.push($(this).val());
      });

      $html.find('option').each(function() {
        if (activeFilters.indexOf($(this).val()) !== -1) {
          $(this).wrap('<span/>');
        }
      });

      $html.find('select').val($html.find('select > option:first').val());

      $html.appendTo(this.$filters);

      var self = this;
      setTimeout(function () {
        self.updateFilterOptions();
      }, 0);
    },
    'change select.filter-type': 'updateFilterOptions',
    'change select.object-type': function (e) {
      this.onSelectChange();
    },
    'change input[name="show-extra-product-data"]': function (e) {
      if ($(e.target).is(':checked')) {
        addExtraProductData = true;
        $(e.target).parent().parent().next().show();
      } else {
        addExtraProductData = false;
        $(e.target).parent().parent().next().hide();
      }   
    },
    'change input[name="show-extra-variant-data"]': function (e) {
      if ($(e.target).is(':checked')) {
        addExtraVariantData = true;
        $(e.target).parent().parent().next().show();
      } else {
        addExtraVariantData = false;
        $(e.target).parent().parent().next().hide();
      }   
    },
  }
});

var PageView = Backbone.View.extend({
  initialize: function () {
    console.log('init export csv page');
    new ExportFormView({el: this.$el.find('form').first()});
  },
  events: {
    'change input[name="diff-email"]': function (e) {
      if ($(e.target).is(':checked')) {
        sendEmail = true;
        $(e.target).parent().parent().next().show();
      } else {
        sendEmail = false;
        $(e.target).parent().parent().next().hide();
      }
    }
  }
});

module.exports = PageView;

}());